import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onApplyClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-black/80 backdrop-blur-xl border-b border-[#5F9BC7]/20 shadow-lg shadow-[#5F9BC7]/5' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-32 md:h-20 pb-4 md:pb-0">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="/images/vf-logo.png" 
              alt="Vital Fusion Coaching Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl md:text-2xl font-bold bg-gradient-to-r from-[#5F9BC7] to-[#FFE7AB] bg-clip-text text-transparent">
              Vital Fusion Coaching
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('results')}
              className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200"
            >
              Results
            </button>
            <button 
              onClick={() => scrollToSection('method')}
              className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200"
            >
              Method
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200"
            >
              FAQ
            </button>
            <button 
              onClick={() => scrollToSection('free-resource')}
              className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200"
            >
              Free Blueprint
            </button>
            <Button 
              onClick={onApplyClick}
              className="bg-gradient-to-r from-[#5F9BC7] to-[#4A8AB0] hover:from-[#4A8AB0] hover:to-[#5F9BC7] text-white px-6 py-2 rounded-lg font-semibold shadow-lg shadow-[#5F9BC7]/30 transition-all duration-300 hover:shadow-[#5F9BC7]/50 hover:scale-105"
            >
              Apply Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-green-500/20 py-4">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('results')}
                className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200 text-left px-4 py-2"
              >
                Results
              </button>
              <button 
                onClick={() => scrollToSection('method')}
                className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200 text-left px-4 py-2"
              >
                Method
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200 text-left px-4 py-2"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200 text-left px-4 py-2"
              >
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('free-resource')}
                className="text-gray-300 hover:text-[#5F9BC7] transition-colors duration-200 text-left px-4 py-2"
              >
                Free Blueprint
              </button>
              <div className="px-4">
                <Button 
                  onClick={onApplyClick}
                  className="w-full bg-gradient-to-r from-[#5F9BC7] to-[#4A8AB0] hover:from-[#4A8AB0] hover:to-[#5F9BC7] text-white px-6 py-3 rounded-lg font-semibold shadow-lg shadow-[#5F9BC7]/30"
                >
                  Apply Now
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
